<div class="notification-content" id="notificationPopup">
    <!-- Heading -->
    <div class="notification-header pl-2 pt-2">
        <div class="notification-hd-title">Notifications</div>
    </div>

    <!-- Notification panel header -->
    <div *ngIf="showNotificationsPanel" class="d-flex justify-content-between align-items-center pt-2 pb-1">
        <small class="text-danger pl-2">All alerts will be archived after 30 days.</small>
        <div (click)="toggleFilterPanel(); $event.stopPropagation();" class="icon-filter cursor-pointer pr-2"><i
                class="fa fa-filter"></i></div>
    </div>

    <!-- Filter panel header -->
    <div *ngIf="showFiltersPanel && !showNotificationsPanel" class="row col-12 p-0 m-0">
        <div class="col-6 filter-header p-0">Filters</div>
        <div (click)="applyFilter($event)" class="col-6 filter-btn-done cursor-pointer">Done</div>
    </div>

    <!-- Notification Panel -->
    <div *ngIf="showNotificationsPanel">
        <!-- Claim and Policy Notifications -->
        <div *ngIf="notificationLocation !== 'main-menu'; else showProfileNotifications">
            <!-- Tabs -->
            <mat-tab-group [selectedIndex]="lastViewedTabIndex" (selectedTabChange)="tabChanged($event)" #matTabGroup>
                <!-- All Alerts -->
                <mat-tab label="All Alerts">
                    <ng-template matTabContent>
                        <div *ngFor="let notification of this.notifications?.claimNotifications.concat(this.notifications?.policyNotifications)"
                             class="notifications-details mb-2 pt-2">
                            <!-- Notifications for policy page -->
                            <span *ngFor="let policyTerms of policy?.terms">
                <div *ngIf="policyTerms?.status !== termStatus.renewal">
                  <div class="row align-items-center mt-1">
                    <div class="col-12 d-flex align-items-center">
                      <div class="col-2 notification-img">
                        <img alt="{{notification?.subject}}" class="notifications-claims"
                             src="../../../assets/images/icons/notifications/{{notification?.type}}/{{notification?.label}}.svg">
                      </div>
                      <div class="col-9 pt-0 pl-0">
                        <span *ngIf="notification?.type === 'claim'"
                              (click)="toggleWarningModal('openNotification', $event, notification, policy?.address?.formattedAddress, policyTerms)">
                          <p [ngClass]="[notification?.notificationStatus === 'UNREAD' ? 'notification-text-bold' : '',
                             notification?.type === 'claim' ? 'cursor-pointer' : '']"
                             class="notification-title mb-1">
                            <span>{{ notification?.subject }}</span>
                          </p>
                          <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                             class="cursor-pointer notification-text mb-1">
                            {{ notification?.text }}
                          </p>
                        </span>
                        <span *ngIf="notification?.type === 'policy'">
                          <p [ngClass]="[notification?.notificationStatus === 'UNREAD' ? 'notification-text-bold' : '',
                             notification?.type === 'claim' ? 'cursor-pointer' : '']"
                             class="notification-title mb-1">
                            <span>{{ notification?.subject }}</span>
                          </p>
                          <p *ngIf="(notification?.label === 'POLICY_PAYMENT_SUCCESSFUL' || notification?.label === 'RECURRING_PAYMENT_DUE'); else alertsWithNavigation"
                             [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                             class="notification-text mb-1">
                            {{ notification?.text }}
                          </p>
                          <ng-template #alertsWithNavigation>
                            <p (click)="toggleWarningModal('openNotification', $event, notification, policy?.address?.formattedAddress, policyTerms)"
                               [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                               class="notification-text-policy mb-1 cursor-pointer">
                              {{ notification?.text }}
                            </p>
                          </ng-template>
                        </span>
                      </div>
                      <div class="col-1 notification-menu">
                        <button (menuOpened)="preventCloseOnClickOut()"
                                [matMenuTriggerFor]="menu" aria-label="notification menu" class="btn-menu-notification">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button mat-menu-item
                                  (click)="toggleWarningModal('delete', $event, notification, policy?.address?.formattedAddress, policyTerms)">
                            <mat-icon style="color: #ff0000">delete</mat-icon>
                            <span>Delete</span>
                          </button>
                          <button (click)="toggleWarningModal('archive', $event, notification, policy?.address?.formattedAddress, policyTerms)"
                                  mat-menu-item *ngIf="notification?.notificationStatus !== 'ARCHIVED'">
                            <mat-icon style="color: #004170">archive</mat-icon>
                            <span>Archive</span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
                            <!-- Notifications for claim-details, claims-list, policy-details -->
                            <span *ngIf="!policy">
                <div class="row align-items-center mt-1">
                  <div class="col-12 d-flex align-items-center">
                    <div class="col-2 notification-img">
                      <img alt="{{notification?.subject}}" class="notifications-claims"
                           src="../../../assets/images/icons/notifications/{{notification?.type}}/{{notification?.label}}.svg">
                    </div>
                    <div class="col-9 pt-0 pl-0">
                      <span *ngIf="notification?.type === 'claim'"
                            (click)="toggleWarningModal('openNotification', $event, notification)">
                        <p [ngClass]="[notification?.notificationStatus === 'UNREAD' ? 'notification-text-bold' : '',
                           notification?.type === 'claim' ? 'cursor-pointer' : '']"
                           class="notification-title mb-1">
                          <span>{{ notification?.subject }}</span>
                        </p>
                        <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                           class="cursor-pointer notification-text mb-1">
                          {{ notification?.text }}
                        </p>
                      </span>
                      <span *ngIf="notification?.type === 'policy'">
                        <p [ngClass]="[notification?.notificationStatus === 'UNREAD' ? 'notification-text-bold' : '',
                           notification?.type === 'claim' ? 'cursor-pointer' : '']"
                           class="notification-title mb-1">
                          <span>{{ notification?.subject }}</span>
                        </p>
                        <p *ngIf="(notification?.label === 'POLICY_PAYMENT_SUCCESSFUL' || notification?.label === 'RECURRING_PAYMENT_DUE'); else alertsWithNavigation"
                           [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                           class="notification-text mb-1">
                          {{ notification?.text }}
                        </p>
                        <ng-template #alertsWithNavigation>
                          <p (click)="toggleWarningModal('openNotification', $event, notification)"
                             [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                             class="notification-text-policy mb-1 cursor-pointer">
                            {{ notification?.text }}
                          </p>
                        </ng-template>
                        </span>
                    </div>
                    <div class="col-1 notification-menu">
                      <button (menuOpened)="preventCloseOnClickOut()"
                              [matMenuTriggerFor]="menu" aria-label="notification menu" class="btn-menu-notification">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu" xPosition="before">
                        <button (click)="toggleWarningModal('delete', $event, notification)" mat-menu-item>
                          <mat-icon style="color: #ff0000">delete</mat-icon>
                          <span>Delete</span>
                        </button>
                        <button mat-menu-item (click)="toggleWarningModal('archive', $event, notification)"
                                *ngIf="notification?.notificationStatus !== 'ARCHIVED'">
                          <mat-icon style="color: #004170">archive</mat-icon>
                          <span>Archive</span>
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
              </span>
                        </div>
                        <div *ngIf="!notifications || notifications?.count==0" class="notifications-details mb-3 pt-4">
                            <div>
                                <div class="row">
                                    <div class="col-3">
                                        <img alt="No Notifications" class="notifications-claims"
                                             src="../../../assets/images/icons/no-notifications.svg">
                                    </div>
                                    <div class="col-9 pt-0 pl-2">
                                        <p class="notification-title">
                                            <span *ngIf="!isFilterApplied">You don't have any notifications yet</span>
                                            <span *ngIf="isFilterApplied">No records found</span>
                                        </p>
                                        <p class="nonotification-text">Your notifications would show up here as they
                                            appear</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-tab>
                <!-- Policy Alerts -->
                <mat-tab label="Policy">
                    <ng-template matTabContent>
                        <div *ngFor="let notification of notifications?.policyNotifications"
                             class="notifications-details mb-2 pt-2">
                            <!-- Notifications for policy page -->
                            <span *ngFor="let policyTerms of policy?.terms">
                <div *ngIf="policyTerms?.status !== termStatus.renewal">
                  <div class="row align-items-center mt-1">
                    <div class="col-12 d-flex align-items-center">
                      <div class="col-2 notification-img">
                        <img alt="{{notification?.subject}}" class="notifications-claims"
                             src="../../../assets/images/icons/notifications/{{notification?.type}}/{{notification?.label}}.svg">
                      </div>
                      <div class="col-9 pt-0 pl-0">
                        <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                           class="notification-title mb-1">
                          <span>{{ notification?.subject }}</span>
                        </p>
                        <p *ngIf="(notification?.label === 'POLICY_PAYMENT_SUCCESSFUL' || notification?.label === 'RECURRING_PAYMENT_DUE'); else alertsWithNavigation"
                           [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                           class="notification-text mb-1">
                          {{ notification?.text }}
                        </p>
                        <ng-template #alertsWithNavigation>
                          <p (click)="toggleWarningModal('openNotification', $event, notification, policyTerms)"
                             [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                             class="notification-text-policy mb-1 cursor-pointer">
                            {{ notification?.text }}
                          </p>
                        </ng-template>
                      </div>
                      <div class="col-1 notification-menu">
                        <button (menuOpened)="preventCloseOnClickOut()"
                                [matMenuTriggerFor]="menu" aria-label="notification menu" class="btn-menu-notification">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button (click)="toggleWarningModal('delete', $event, notification, policyTerms)"
                                  mat-menu-item>
                            <mat-icon style="color: #ff0000">delete</mat-icon>
                            <span>Delete</span>
                          </button>
                          <button mat-menu-item
                                  (click)="toggleWarningModal('archive', $event, notification, policyTerms)"
                                  *ngIf="notification?.notificationStatus !== 'ARCHIVED'">
                            <mat-icon style="color: #004170">archive</mat-icon>
                            <span>Archive</span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
                            <!-- Notifications for claim-details, claims-list, policy-details -->
                            <span *ngIf="!policy">
                <div class="row align-items-center mt-1">
                  <div class="col-12 d-flex align-items-center">
                    <div class="col-2 notification-img">
                      <img alt="{{notification?.subject}}" class="notifications-claims"
                           src="../../../assets/images/icons/notifications/{{notification?.type}}/{{notification?.label}}.svg">
                    </div>
                    <div class="col-9 pt-0 pl-0">
                      <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                         class="notification-title mb-1">
                        <span>{{ notification?.subject }}</span>
                      </p>
                      <p *ngIf="(notification?.label === 'POLICY_PAYMENT_SUCCESSFUL' || notification?.label === 'RECURRING_PAYMENT_DUE'); else alertsWithNavigation"
                         [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                         class="notification-text mb-1">
                        {{ notification?.text }}
                      </p>
                      <ng-template #alertsWithNavigation>
                        <p (click)="toggleWarningModal('openNotification', $event, notification)"
                           [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                           class="notification-text-policy mb-1 cursor-pointer">
                          {{ notification?.text }}
                        </p>
                      </ng-template>
                    </div>
                    <div class="col-1 notification-menu">
                      <button (menuOpened)="preventCloseOnClickOut()"
                              [matMenuTriggerFor]="menu" aria-label="notification menu" class="btn-menu-notification">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu" xPosition="before">
                        <button (click)="toggleWarningModal('delete', $event, notification)" mat-menu-item>
                          <mat-icon style="color: #ff0000">delete</mat-icon>
                          <span>Delete</span>
                        </button>
                        <button mat-menu-item (click)="toggleWarningModal('archive', $event, notification)"
                                *ngIf="notification?.notificationStatus !== 'ARCHIVED'">
                          <mat-icon style="color: #004170">archive</mat-icon>
                          <span>Archive</span>
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
              </span>
                        </div>
                        <div *ngIf="notifications?.policyNotifications?.length === 0"
                             class="notifications-details mb-3 pt-4">
                            <div>
                                <div class="row">
                                    <div class="col-3">
                                        <img alt="No Notifications" class="notifications-claims"
                                             src="../../../assets/images/icons/no-notifications.svg">
                                    </div>
                                    <div class="col-9 pt-0 pl-2">
                                        <p class="notification-title">
                                            <span *ngIf="!isFilterApplied">You don't have any policy notifications yet</span>
                                            <span *ngIf="isFilterApplied">No records found</span>
                                        </p>
                                        <p class="nonotification-text">Your policy notifications would show up here as
                                            they appear</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-tab>
                <!-- Claim Alerts -->
                <mat-tab label="Claims">
                    <ng-template matTabContent>
                        <div *ngFor="let notification of notifications?.claimNotifications"
                             class="notifications-details mb-2 pt-2">
                            <!-- Notifications for policy page -->
                            <span *ngFor="let policyTerms of policy?.terms">
                <div *ngIf="policyTerms?.status !== termStatus.renewal">
                  <div class="row align-items-center mt-1">
                    <div class="col-12 d-flex align-items-center">
                      <div class="col-2 notification-img">
                        <img alt="{{notification?.subject}}" class="notifications-claims"
                             src="../../../assets/images/icons/notifications/{{notification?.type}}/{{notification?.label}}.svg">
                      </div>
                      <div (click)="toggleWarningModal('openNotification', $event, notification, policyTerms)"
                           class="col-9 pt-0 pl-0">
                        <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                           class="notification-title mb-1">
                          <span>{{ notification?.subject }}</span>
                        </p>
                        <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                           class="notification-text mb-1">
                          {{ notification?.text }}
                        </p>
                      </div>
                      <div class="col-1 notification-menu">
                        <button (menuOpened)="preventCloseOnClickOut()"
                                [matMenuTriggerFor]="menu" aria-label="notification menu" class="btn-menu-notification">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button (click)="toggleWarningModal('delete', $event, notification, policyTerms)"
                                  mat-menu-item>
                            <mat-icon style="color: #ff0000">delete</mat-icon>
                            <span>Delete</span>
                          </button>
                          <button mat-menu-item
                                  (click)="toggleWarningModal('archive', $event, notification, policyTerms)"
                                  *ngIf="notification?.notificationStatus !== 'ARCHIVED'">
                            <mat-icon style="color: #004170">archive</mat-icon>
                            <span>Archive</span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
                            <!-- Notifications for claim-details, claims-list, policy-details -->
                            <span *ngIf="!policy">
                <div class="row align-items-center mt-1">
                  <div class="col-12 d-flex align-items-center">
                    <div class="col-2 notification-img">
                      <img alt="{{notification?.subject}}" class="notifications-claims"
                           src="../../../assets/images/icons/notifications/{{notification?.type}}/{{notification?.label}}.svg">
                    </div>
                    <div (click)="toggleWarningModal('openNotification', $event, notification)" class="col-9 pt-0 pl-0">
                      <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                         class="notification-title mb-1">
                        <span>{{ notification?.subject }}</span>
                      </p>
                      <p [ngClass]="{'notification-text-bold' : notification?.notificationStatus === 'UNREAD'}"
                         class="notification-text mb-1">
                        {{ notification?.text }}
                      </p>
                    </div>
                    <div class="col-1 notification-menu">
                      <button (menuOpened)="preventCloseOnClickOut()"
                              [matMenuTriggerFor]="menu" aria-label="notification menu" class="btn-menu-notification">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu" xPosition="before">
                        <button (click)="toggleWarningModal('delete', $event, notification)" mat-menu-item>
                          <mat-icon style="color: #ff0000">delete</mat-icon>
                          <span>Delete</span>
                        </button>
                        <button mat-menu-item (click)="toggleWarningModal('archive', $event, notification)"
                                *ngIf="notification?.notificationStatus !== 'ARCHIVED'">
                          <mat-icon style="color: #004170">archive</mat-icon>
                          <span>Archive</span>
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
              </span>
                        </div>
                        <div *ngIf="notifications?.claimNotifications?.length === 0"
                             class="notifications-details mb-3 pt-4">
                            <div>
                                <div class="row">
                                    <div class="col-3">
                                        <img alt="No Notifications" class="notifications-claims"
                                             src="../../../assets/images/icons/no-notifications.svg">
                                    </div>
                                    <div class="col-9 pt-0 pl-2">
                                        <p class="notification-title">
                                            <span *ngIf="!isFilterApplied">You don't have any claim notifications yet</span>
                                            <span *ngIf="isFilterApplied">No records found</span>
                                        </p>
                                        <p class="nonotification-text">Your claim notifications would show up here as
                                            they appear</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>

        <!-- Profile Notifications -->
        <ng-template #showProfileNotifications>
      <span>
        <div *ngFor="let notification of notifications?.notificationDetails" class="notifications-details mb-2 pt-2">
          <div class="row align-items-center">
            <div class="col-12 d-flex align-items-center">
              <div class="col-2 notification-img">
               <img alt="profile-alerts"
                    class="notifications-claims"
                    src="../../../assets/images/icons/notifications/Profile/profile-alert.svg">
              </div>
              <div class="col-9 pt-0 pl-0">
                <p class="notification-title mb-2">
                <span>{{ notification?.subject }}</span>
              </p>
                <p class="notification-text mb-2">
                  {{ notification?.text }}
                </p>
              </div>
              <div class="col-1 notification-menu">
                <button (menuOpened)="preventCloseOnClickOut()"
                        [matMenuTriggerFor]="menu" aria-label="notification menu" class="btn-menu-notification">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu" xPosition="before">
                  <button (click)="toggleWarningModal('delete', $event, notification)" mat-menu-item>
                    <mat-icon style="color: #ff0000">delete</mat-icon>
                    <span>Delete</span>
                  </button>
                  <button (click)="toggleWarningModal('archive', $event, notification)"
                          *ngIf="notification?.notificationStatus !== 'ARCHIVED'"
                          mat-menu-item>
                    <mat-icon style="color: #004170">archive</mat-icon>
                    <span>Archive</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </div>
      </span>
            <div *ngIf="!notifications || notifications?.count==0" class="notifications-details mb-3 pt-4">
                <div>
                    <div class="row">
                        <div class="col-3">
                            <img alt="No Notifications" class="notifications-claims"
                                 src="../../../assets/images/icons/no-notifications.svg">
                        </div>
                        <div class="col-9 pt-0 pl-2">
                            <p class="notification-title">
                                <span *ngIf="!isFilterApplied">You don't have any notifications yet</span>
                                <span *ngIf="isFilterApplied">No records found</span>
                            </p>
                            <p class="nonotification-text">Your notifications would show up here as they appear</p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <!-- Filter Panel -->
    <div *ngIf="showFiltersPanel">
        <div class="filter-container">
            <div class="mt-3">
                <div class="label-container">
                    <label>Filter By</label>
                </div>
                <section class="filter-section">
                    <ul class="filter-list">
                        <li *ngFor="let option of filterOptions; let i = index">
                            <mat-checkbox (change)="onFilterOptionChange(option, $event, i)"
                                          [checked]="selectedIndex === i"
                                          color="primary">
                                <span>{{ option?.description }}</span>
                            </mat-checkbox>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </div>
</div>
